import { refProcessGroup } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { ProcessGroupDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["PROCESS_GROUP_QUEUE_URL"]

export const getRefProcessGroupData = async (
  tx: DbTransaction,
  id: string,
): Promise<ProcessGroupDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refProcessGroup.id,
      groupName: refProcessGroup.groupName,
      groupType: refProcessGroup.groupType,
      overrideUNCode: refProcessGroup.overrideUNCode,
      overrideCharacteristic: refProcessGroup.overrideCharacteristic,
      active: refProcessGroup.active,
      updatedAt: refProcessGroup.updatedAt,
      updatedBy: refProcessGroup.updatedBy,
    })
    .from(refProcessGroup)
    .where(eq(refProcessGroup.id, parseInt(id)))

  if (!row) {
    console.error(`RefProcessGroup with id ${id} not found`)
    return
  }

  const refProcessGroupDoc: ProcessGroupDoc = {
    id: row.id.toString(),
    group_name: row.groupName,
    group_type: row.groupType,
    override_un_code: row.overrideUNCode,
    override_characteristic: row.overrideCharacteristic,
    active: row.active,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refProcessGroupDoc,
  })

  return refProcessGroupDoc
}

export const saveRefProcessGroupToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefProcessGroupData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}

export const saveRefProcessGroupToSearchByName = async (
  tx: DbTransaction,
  groupName: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const [row] = await tx
    .select({ id: refProcessGroup.id })
    .from(refProcessGroup)
    .where(eq(refProcessGroup.groupName, groupName))

  if (!row) {
    console.error(`RefProcessGroup with groupName ${groupName} not found`)
    return
  }

  const doc = await getRefProcessGroupData(tx, row.id.toString())

  if (!doc) {
    console.error(`Failed to prepare document for groupName: ${groupName}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
